import {normalizeChoose} from '../../sheets/character/model/normalize-choose';
import type {ChooseGroup} from '../../sheets/character/model/types';

type RepeatableFeat = {
	features?: Array<{choose?: unknown}>;
};

const collectUniqueNotes = (groups: ChooseGroup[]): string[] =>
	groups.flatMap((group) => [
		...(group.params.uniqueNote ? [group.params.uniqueNote] : []),
		...(group.options || []).flatMap((option) => collectUniqueNotes(option.choose || [])),
	]);

export function repeatableText(feat: RepeatableFeat): string {
	const notes = [
		...new Set((feat.features || []).flatMap((feature) => collectUniqueNotes(normalizeChoose(feature.choose)))),
	];
	const condition = notes.length ? `, но ${notes.join(' и ')}` : '';
	return `*_Повторяемость._* Вы можете взять эту черту более одного раза${condition}.`;
}
